import React from 'react';
import PoorText from 'components/PoorText';
import MarketInsightCtaLinkList from 'components/MarketInsightCtaLinkList';
import MarketAccessLinksBlock from 'components/MarketAccessLinksBlock';
import MarketAccessLinksColumn from 'components/MarketAccessLinksBlock/MarketAccessLinksColumn.jsx';
import PropTypes from 'prop-types';

import './MarketInsightLinksBlock.scss';

const MarketInsightLinksBlock = ({
  heading,
  introHtml,
  ctaItems,
  linkColumns,
}) => {
  return (
    <div className="market-insight-links-block">
      <div className="market-insight-links-block__container">
        {heading && (
          <h2 className="market-insight-links-block__heading">{heading}</h2>
        )}
        {introHtml && (
          <PoorText
            text={introHtml}
            className="poor-text_in-market-insight-links-block"
          />
        )}
        <div className="market-insight-links-block__content">
          {ctaItems && (
            <MarketInsightCtaLinkList
              {...ctaItems}
              className="market-insight-links-block__cta-links"
            />
          )}
          <MarketAccessLinksBlock
            linkColumns={linkColumns}
            className="market-access-links-block_in-market-insight-links-block"
          />
        </div>
      </div>
    </div>
  );
};

MarketInsightLinksBlock.propTypes = {
  heading: PropTypes.string,
  introHtml: PropTypes.string,
  ctaItems: PropTypes.exact(MarketInsightCtaLinkList.propTypes),
  linkColumns: PropTypes.arrayOf(
    PropTypes.exact(MarketAccessLinksColumn.propTypes)
  ),
};

export default MarketInsightLinksBlock;
